export default __webpack_public_path__ + "static/media/uploader-trivia-1.1aba165e.png";